import { Koi } from '@ksyos/koi';
import type { TypedReadSchema } from '@common/formEngine/typedReadSchema.types';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { getTextAreaStringSchema } from '@common/validation/utils/getTextAreaStringSchema';

export type BariPreMedConsultPlanAppointmentData = {
    toelichting: string | null;
};

export type BariPreMedConsultPlanAppointmentReadKey = keyof BariPreMedConsultPlanAppointmentData;
export type BariPreMedConsultPlanAppointmentReadLabel = 'Toelichting';

export const bariPreMedConsultPlanAppointmentReadSchema: TypedReadSchema<
    BariPreMedConsultPlanAppointmentReadKey,
    BariPreMedConsultPlanAppointmentReadLabel
>[] = [{ items: [{ key: 'toelichting', label: 'Toelichting' }] }];

const bariPreMedConsultPlanAppointmentFinal: TypedSchema<BariPreMedConsultPlanAppointmentData> = {
    toelichting: getTextAreaStringSchema(true),
};

const bariPreMedConsultPlanAppointmentDraft: TypedSchema<BariPreMedConsultPlanAppointmentData> = {
    ...bariPreMedConsultPlanAppointmentFinal,
};

export const bariPreMedConsultPlanAppointmentDraftSchema = Koi.object(bariPreMedConsultPlanAppointmentDraft);
export const bariPreMedConsultPlanAppointmentFinalSchema = Koi.object(bariPreMedConsultPlanAppointmentFinal);
